// node_modules
import axios, { AxiosError } from "axios";
import { LoggingConstants } from "Constants";
import { ToastTypeEnum } from "Enums";
// Helpers
import { AxiosHelperSingleton, PendoHelperSingleton, ToastHelperSingleton } from "Helpers";
// Types
import { TSideNoteDTO, TSideNotePostDTO } from "Types";

export class SideNoteController {
    public async createAsync(sideNote: TSideNotePostDTO): Promise<boolean> {
        // Logging
        PendoHelperSingleton.trackEvent(`${LoggingConstants.DYNAMIC_DELIVERY}SidenotesCreate`);

        try {
            return (await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/sidenotes/create`, sideNote)).status === 200;
        } catch (error: any) {
            if (axios.isAxiosError(error)) {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this sidenote.");
                    return false;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not to edit this sidenote.");
            return false;
        }
    }

    public async deleteAsync(sideNote: TSideNoteDTO): Promise<void> {
        // Logging
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SidenotesDelete`, {
            sidenoteId: sideNote.id
        });

        try {
            await axios.delete(`${AxiosHelperSingleton.getServerBaseURL()}api/sidenotes/${sideNote.id}`);
        } catch (error: any) {
            if (axios.isAxiosError(error)) {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this sidenote.");
                    return;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to delete the sidenote.");
            return;
        }
    }

    public async updateAsync(sideNote: TSideNoteDTO): Promise<boolean> {
        // Logging
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SidenotesUpdate`, {
            sidenoteId: sideNote.id
        });

        const formData = new FormData();
        formData.append("text", sideNote.text);
        try {
            return (await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/sidenotes/${sideNote.id}`,
                formData, { headers: { "Content-Type": "multipart/form-data" } })).status === 200;
        } catch (error: any) {
            if (axios.isAxiosError(error)) {
                const axiosError = error as AxiosError;
                if (axiosError.response && axiosError.response.status === 409) {
                    ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Somebody is already editing this sidenote.");
                    return false;
                }
            }

            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not to edit this sidenote.");
            return false;
        }
    }
}

export const SideNoteControllerSingleton = new SideNoteController();